<script lang="ts" setup>
import LabelText from '~/components/form-elements/LabelText.vue'

const model = defineModel<number>()

const props = withDefaults(
  defineProps<{
    isRequired?: boolean
    labelText?: string | null
  }>(),
  { isRequired: false, labelText: null }
)

const highlightedStarsCount = ref(0)

function getStarClass (x: number): string {
  switch (true) {
    case x <= model.value!:
      return 'filled'
    case x <= highlightedStarsCount.value:
      return 'highlighted'
    default:
      return 'empty'
  }
}

function getStarIcon (x: number): string {
  // TODO: Produces an error if you clicked on the first star. The problem appeared after installing nuxt-svgo.
  // return x > props.model ? 'outlined/star-outline' : 'outlined/star'

  return 'outlined/star'
}
</script>

<template>
  <div>
    <LabelText class="mb-1" :is-required="isRequired" :value="labelText" />

    <div class="star-rating">
      <SvgIcon
        v-for="x in 5"
        :key="x"
        class="star-rating__star cursor-pointer"
        :class="getStarClass(x)"
        :name="getStarIcon(x)"
        @click="model = x"
        @mouseleave="highlightedStarsCount = 0"
        @mouseover="highlightedStarsCount = x"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.star-rating {
  font-size: 32px;

  &__star {
    padding: 0 4px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    &.empty {
      color: color.mix(variables.$main-gray-color, white, 20%);
    }

    &.filled,
    &.highlighted {
      color: variables.$main-light-yellow-color;
    }
  }
}
</style>
